import { combineReducers } from 'redux';
import UserReducer from './user-reducer';
import AuthReducer from './auth-reducer';
import ReportReducer from './report-reducer';
import TransactionsReducer from './transaction-reducer';
import AdministrationReducer from './administration-reducer';
import FreshdeskReducer from './freshdesk-reducer';
import ApiReducer from './api-reducer';
import { AUTH_USER } from '../actions/types';

const appReducer = combineReducers({
  api: ApiReducer,
  auth: AuthReducer,
  user: UserReducer,
  report: ReportReducer,
  transactions: TransactionsReducer,
  administrationData: AdministrationReducer,
  freshdesk: FreshdeskReducer,
});

const rootReducer = (state, action) => {
  
  if (action.type === AUTH_USER && action.payload === false) {
    state = undefined;
  }
  
  return appReducer(state, action);
};

export default rootReducer;